import { onlineManager } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

/**
 * Reactive device-connectivity flag backed by TanStack Query's onlineManager
 * (driven by the Capacitor Network bridge, see common/onlineManagerBridge.ts).
 * Re-renders the caller whenever connectivity changes, so offline-only actions
 * can be disabled live.
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    (onChange) => onlineManager.subscribe(() => onChange()),
    () => onlineManager.isOnline(),
    () => true
  );
}
